import axios, { AxiosError } from 'axios';
import { keepPreviousData, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { GET_OFFICE_STATISTICS } from '@/constants';
import { ErrorResponse, OfficeAdminStatisticsRo } from '@/types';

export const useGetOfficeStatistics = (
  days: number,
  options?: Partial<UseQueryOptions<OfficeAdminStatisticsRo, AxiosError<ErrorResponse>>>,
) =>
  useQuery<OfficeAdminStatisticsRo, AxiosError<ErrorResponse>>({
    queryKey: ['office-statistics', days],
    queryFn: () =>
      axios
        .get<OfficeAdminStatisticsRo>(GET_OFFICE_STATISTICS, { params: { days } })
        .then((res) => res.data),
    placeholderData: keepPreviousData,
    ...options,
  });
